<div class="kill-keys-container">
  <fui-heading [text]="'Kill Keys'" [level]="5"></fui-heading>
  @if (loading) {
    <div>Loading...</div>
  }
  @if (!loading) {
    <div>
      @if (!uploader.queue.length && !uploadingComplete && !killResult) {
        <div ng2FileDrop class="drop-zone" [class.hovering]="hasBaseDropZoneOver" (fileOver)="fileOverBase($event, 'preview')" [uploader]="uploader">
          "Drop a file here..."
          <br />
          <span class="text-sm">Accepted file formats: .csv</span>
          <br />
          <br />
          <div class="text-center">
            or
            <input aria-label="drop file" type="file" ng2FileSelect [uploader]="uploader" />
          </div>
        </div>
      }
      @if (keysToKill.length && !uploader.isUploading && !fileResponse) {
        <h4 class="section-header m-t-20">Keys to kill:</h4>
        <div>
          <code>
            @for (key of keysToKill; track key) {
              <div>
                {{ key }}
              </div>
            }
          </code>
        </div>
        <br />
        <button class="btn btn-danger m-t-10" (click)="killKeys()" [disabled]="killing">
          {{ killing ? "Killing..." : "Kill Keys" }}
        </button>
      }
      @if (killResult) {
        <h4 class="section-header m-t-20">{{ killResult.deletedKeys.length > 0 ? "Deleted Keys:" : "No keys where deleted" }}</h4>
        <code>
          @for (key of killResult.deletedKeys; track key) {
            <div>
              {{ key }}
            </div>
          }
        </code>
        <br />
        @if (killResult.usedKeys.length > 0) {
          <div>
            <h4 class="section-header m-t-20">Keys that are being used:</h4>
            <code>
              @for (key of killResult.usedKeys; track key) {
                <div>
                  {{ key }}
                </div>
              }
            </code>
            <br />
          </div>
        }
        @if (killResult.noExistKeys.length > 0) {
          <div>
            <h4 class="section-header m-t-20">Keys that do not exist:</h4>
            <code>
              @for (key of killResult.noExistKeys; track key) {
                <div>
                  {{ key }}
                </div>
              }
            </code>
          </div>
        }
      }
    </div>
  }
</div>
